import { useGetQuickSelectSeasons } from "@/orval/gen"
import { DatePickerPreset } from "@mantine/dates"

export function useSeasonPresets() {
  const { data: seasons, isLoading } = useGetQuickSelectSeasons()
  const presets: DatePickerPreset<"range">[] | undefined = React.useMemo(() => {
    return seasons?.map((season) => ({
      label: season.name,
      value: [season.startDate ?? null, season.endDate ?? null],
    }))
  }, [seasons])
  return { presets, isLoading }
}
